<div class="page-head-section">
  <p>National Championship</p>
</div>

<div class="rules-content">
  <!-- <p class="subhead">Title</p> -->
  <ul>
    <li *ngFor="let user of OrderData"    (click)="toLink(user.link)"   class="rules-row">{{ user.name }}</li>
  </ul>

</div>
